module.exports = __webpack_public_path__ + "img/sm-oval-4.143f21c9.png";